// 管理员菜单

let commonMenu = [
    // 营销管理
    {
        path: '/p0',
        component: "HomeView",
        name: '营销管理',
        redirect:'/common/injuriesList',
        parent:true,
        menuId:2,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"派单管理",
                menuId:152,
                children:[
                    {               
                        pageAddress:"commonPage/customerIntentionAdd", 
                        path:"/commonPage/customerIntentionAdd",
                        hidden:true,
                        name:"新增客户意向",
                    },
                    {               
                        pageAddress:"commonPage/customerIntentionDetail", 
                        path:"/commonPage/customerIntentionDetail",
                        hidden:true,
                        name:"客户意向详情",
                    },
                ]
            },
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"案例宣传",
                menuId:153,
                children:[
                    {
                        pageAddress:"casePublicize/PropagandaDetails", 
                        path:"/casePublicize/PropagandaDetails",
                        hidden:true,
                        name:"宣传详情",
                    }
                ]
            },
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"合同管理",
                menuId:85,
                children:[
                    
					// {
					// 	pageAddress:"mm/MMcontractData",
					// 	path:"/common/MMcontractData",
					// 	component:"contractData",
					// 	name:"合同总纲",//营销视窗
					// 	meta:{ 
					// 		keepAlive:true,
					// 	}
                    // },
                    // {
                    //     pageAddress:"cm/CMProjectModifyList",
                    //     path:"/cm/project/CMProjectModifyList",
                    //     component:"CMProjectModifyList",
                    //     name:"变更合同"
                    // },
                    {
                        pageAddress:"CommonContractModifyDetail",
                        path:"/common/contractModify/CommonContractModifyDetail",
                        hidden:true,
                        name:"变更合同详情"
                    },
					{
						pageAddress:"commonPage/dataReport/contractDataInfo",
						path:"/common/contractDataInfo",
						component:"contractDataInfo",
						hidden:true,
						name:"合同详情",
					},
                    
                ]
            },
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"公关管理",
                menuId:11,
                children:[
                    // {
                    //     pageAddress:"commonPage/projectManage/injuriesList",
                    //     path:"/common/injuriesList",
                    //     name:"事故管理",
                    // },

                    {
                        pageAddress:"commonPage/projectManage/injuriesDetail",
                        path:"/common/injuriesDetail",
                        component:"injuriesDetail",
                        name:"事故详情",
                        hidden:true,
                    },
                    {
                        pageAddress:"commonPage/projectManage/injuriesAdd",
                        path:"/common/injuriesAdd",
                        component:"injuriesAdd",
                        name:"添加伤亡事故",
                        hidden:true,
                    },
                    {
                        pageAddress:"commonPage/projectManage/injuriesModify",
                        path:"/common/injuriesModify",
                        component:"injuriesModify",
                        name:"编辑事故详情",
                        hidden:true,
                    },
                    // {
                    //     pageAddress:"commonPage/complaintManage/complaintList",
                    //     path:"/common/complaintList",
                    //     name:"投诉管理"
                    // },	
                    {
                        pageAddress:"commonPage/complaintManage/addComplainList",
                        path:"/common/addComplainList",
                        hidden:true, 
                        name:"添加投诉"
                    },
                    {
                        pageAddress:"commonPage/complaintManage/complainEdit",
                        path:"/common/complainEdit",
                        hidden:true, 
                        name:"编辑投诉"
                    },
                    {
                        pageAddress:"commonPage/complaintManage/complaintDetail",
                        path:"/common/complaintDetail",
                        hidden:true, 
                        name:"投诉详情"
                    },
                    // {
                    //     pageAddress:"commonPage/projectManage/adminSanctionList",
                    //     path:"/common/adminSanctionList",
                    //     name:"行政处罚"
                    // },
                    {
                        pageAddress:"commonPage/projectManage/adminSanctionAdd",
                        path:"/common/adminSanctionAdd",
                        hidden:true, 
                        name:"添加整改单"
                    },
                    {
                        pageAddress:"commonPage/projectManage/adminSanctionEdit",
                        path:"/common/adminSanctionEdit",
                        hidden:true, 
                        name:"编辑整改单"
                    },
                    {
                        pageAddress:"commonPage/projectManage/adminSanctionDetail",
                        path:"/common/adminSanctionDetail",
                        hidden:true, 
                        name:"整改单详情"
                    },
					// {
                    //     pageAddress:"commonPage/complaintManage/litigationList",
                    //     path:"/common/litigationList",
                    //     name:"诉讼管理"
                    // },	
                    {
                        pageAddress:"commonPage/complaintManage/addLitigation",
                        path:"/common/addLitigation",
                        hidden:true, 
                        name:"添加诉讼"
                    },
                    {
                        pageAddress:"commonPage/complaintManage/editLitigation",
                        path:"/common/editLitigation",
                        hidden:true, 
                        name:"编辑诉讼"
                    },
                    {
                        pageAddress:"commonPage/complaintManage/litigationDetail",
                        path:"/common/litigationDetail",
                        hidden:true, 
                        name:"诉讼详情"
                    },
                    // {
                    //     pageAddress:"commonPage/otherAnomalies/otherAnomaliesList",
                    //     path:"/common/otherAnomaliesList",
                    //     name:"其他异常"
                    // },	
                ]
            },
            {
                parent:true,
                component:"Navigation",
                redirect:'/common/problemFeedbackList',
                path:"/home",
                name:"反馈管理",
                menuId:12,
                children:[
                    // {
                    //     path:"/common/problemFeedbackList",
                    //     component:"ProblemFeedbackView",
                    //     name:"问题反馈"
                    // },
                    {
                        path:"/common/problemFeedbackDetail",
                        hidden:true,
                        component:"ProblemFeedbackDetailView",
                        name:"问题反馈详情"
                    },
                ]
            },
        ]
    },
    // 运营管理
    {
        path:'/p1',
        redirect: '/common/projectPreparation',
        component: "HomeView",
        name: '运营管理',
        parent:true,
        menuId:3,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"运营数据",
                menuId:110,
                children:[
                    				
                    // {
                    //     pageAddress:"operation/operationStatisticsIndexView",
                    //     path:"/operation/operationStatistics",
                    //     name:"运营统计"
                    // },  
                    
                ]
            },
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"项目进度",
                menuId:14,
                children:[
                    // 暂时添加
                    {
                        pageAddress:"cm/CMTempProjectReadView", 
                        path:"/cm/temp_project/read_view",
                        hidden:true,
                        name:"在跟项目详情"
                    },
                    				
                    // {
                    //     pageAddress:"cm/CMRunningProjectIndexView",
                    //     path:"/cm/project/underConstructionProject",
                    //     name:"在建项目"
                    // },  
                    // {
                    //     pageAddress:"cm/CMFinishedIndexView",
                    //     path:"/cm/project/finishedProject",
                    //     component:"CMFinishedIndexView",
                    //     name:"完工项目"
                    // },
                    
                    {
                        pageAddress:"cm/CMRunningProjectEditView",
                        path:"/cm/project/track",
                        hidden:true,
                        name:"项目详情"
                    },
                    {
                        pageAddress:"cm/CMFinishedAccountApply",
                        path:"/cm/CMFinishedAccountApply",
                        hidden:true,
                        name:"完工结算申请"
                    },
                    // {
                    //     pageAddress:"commonPage/projectManage/projectQueryList",
                    //     path:"/common/projectQueryList",
                    //     name:"项目查询"
                    // },
                    {               
                        pageAddress:"commonPage/projectManage/editProjectInformation", 
                        path:"/common/editProjectInformation",
                        hidden:true,
                        name:"编辑项目信息",
                    },
                    // {
                    //     pageAddress:"commonPage/projectManage/fileList",
                    //     path:"/common/fileList",
                    //     component:"fileList",
                    //     name:"项目资料管理"
                    // },
                    {
                        pageAddress:"commonPage/projectManage/fileDetail",
                        path:"/common/fileDetail",
                        component:"fileDetail",
                        hidden:true,
                        name:"项目资料详情"
                    },
                    {
                        pageAddress:"commonPage/enginnerManage/securityScoreTable",
                        path:"/common/securityScoreTable",
                        component:"securityScoreTable",
                        hidden:true,
                        name:"工地安全文明施工记录表"
                    },
                    {
                        pageAddress:"commonPage/enginnerManage/qualityScoreTable",
                        path:"/common/qualityScoreTable",
                        component:"qualityScoreTable",
                        hidden:true,
                        name:"工地现场质量监察记录表"
                    },
                    {
                        pageAddress:"commonPage/enginnerManage/projectFinishedTable",
                        path:"/common/projectFinishedTable",
                        component:"projectFinishedTable",
                        hidden:true,
                        name:"工程竣工验收记录表"
                    },
                ]
            },
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"用印管理",
                menuId:16,
                children:[
                    // {
                    //     pageAddress:"fm/FMSealList",
                    //     path:"/fm/FMSealList",
                    //     name:"用章记录"
                    // },
                    {
                        pageAddress:"fm/FMSealDetail",
                        path:"/fm/FMSealDetail",
                        name:"用章详情",
                        hidden:true,
                    },
                    // {
                    //     pageAddress:"cm/applySeal",
                    //     path:"/cm/applySeal",
                    //     name:"盖章申请"
                    // },
                    {
                        pageAddress:"cm/cmApplySealDetail",
                        path:"/cm/cmApplySealDetail",
                        name:"盖章申请详情",
                        hidden:true,
                    },
                    {
                        pageAddress:"cm/cmApplySealEdit",
                        path:"/cm/cmApplySealEdit",
                        name:"盖章申请",
                        hidden:true,
                    },
                    // {
                    //     pageAddress:"cm/sealApply/sealApplicationIndexView",
                    //     path:"/cm/sealApplicationIndexView",
                    //     name:"用印申请"
                    // },
                    {
                        pageAddress:"cm/sealApply/sealApplicationAdd",
                        path:"/cm/sealApplicationAdd",
                        name:"新增用印申请",
                        hidden:true,
                    },
                    {
                        pageAddress:"cm/sealApply/sealApplicationEdit",
                        path:"/cm/sealApplicationEdit",
                        name:"编辑用印申请",
                        hidden:true,
                    },
                    {
                        pageAddress:"cm/sealApply/sealApplicationDetail",
                        path:"/cm/sealApplicationDetail",
                        name:"审批详情",
                        hidden:true,
                    },
                    {
                        pageAddress:"cm/sealApply/sealApplicationUpload",
                        path:"/cm/sealApplicationUpload",
                        name:"上传盖章文件",
                        hidden:true,
                    },
                    {
                        pageAddress:"cm/sealApply/sealApplicationOtheradd",
                        path:"/cm/sealApplicationOtheradd",
                        name:"新增用印申请",
                        hidden:true,
                    },
                    {
                        pageAddress:"cm/sealApply/sealApplicationOtherDetail",
                        path:"/cm/sealApplicationOtherDetail",
                        name:"审批详情",
                        hidden:true,
                    },
                    {
                        pageAddress:"cm/sealApply/sealApplicationOtherEdit",
                        path:"/cm/sealApplicationOtherEdit",
                        name:"编辑用印申请",
                        hidden:true,
                    },
                ]
            },
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"资质证书",
                menuId:121,
                children:[
                    // {
                    //     pageAddress:"commonPage/projectManage/companyQualification",
                    //     path:"/common/companyQualification",
                    //     component:"companyQualification",
                    //     name:"公司资质"
                    // },
                    // {
                    //     pageAddress:"commonPage/projectManage/employeeCertificate",
                    //     path:"/common/employeeCertificate",
                    //     name:"员工证书"
                    // },
                    {
                        pageAddress:"commonPage/projectManage/editEmployeeCertificate",
                        path:"/common/editEmployeeCertificate",
                        name:"编辑员工证书",
                        hidden:true,
                    },
                    {
                        pageAddress:"commonPage/projectManage/employeeCertificateDetail",
                        path:"/common/employeeCertificateDetail",
                        name:"员工证书详情",
                        hidden:true,
                    },
                ]
            },
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"立项管理",
                menuId:13,
                children:[
                    //默认视窗//派单管理
                    // {               
                    //     pageAddress:"commonPage/customerIntentionList", 
                    //     path:"/commonPage/customerIntentionList",
                    //     name:"客户意向",
                    // },
                    //客服视窗//派单管理
                    // {               
                    //     pageAddress:"cm/customerIntentionList", 
                    //     path:"/cm/customerIntentionList",
                    //     name:"客户意向",
                    // },
                    // {               
                    //     pageAddress:"commonPage/customerIntentionAdd", 
                    //     path:"/commonPage/customerIntentionAdd",
                    //     hidden:true,
                    //     name:"新增客户意向",
                    // },
                    // {               
                    //     pageAddress:"commonPage/customerIntentionDetail", 
                    //     path:"/commonPage/customerIntentionDetail",
                    //     hidden:true,
                    //     name:"客户意向详情",
                    // },
                    // {               
                    //     pageAddress:"commonPage/projectManage/projectPreparation", 
                    //     path:"/common/projectPreparation",
                    //     component:"projectPreparation",
                    //     name:"项目报备",
                    // },
                    // {
                    //     pageAddress:"cm/CMContractEditView0",
                    //     path:"/cm/project/CMContractEditView0",
                    //     hidden:true,
                    //     name:"签约",
                    // },
                    {               
                        pageAddress:"commonPage/projectManage/proPreparationModify", 
                        path:"/common/proPreparationModify",
                        component:"proPreparationModify",
                        hidden:true,
                        name:"编辑立项申请",
                    },
                    {               
                        pageAddress:"commonPage/projectManage/proPreparationRevise", 
                        path:"/common/proPreparationRevise",
                        component:"proPreparationRevise",
                        hidden:true,
                        name:"编辑项目报备",
                    },
                    {               
                        pageAddress:"commonPage/projectManage/proPreparationAdd", 
                        path:"/common/proPreparationAdd",
                        component:"proPreparationAdd",
                        hidden:true,
                        name:"新增立项申请",
                    },
                    {
                        pageAddress:"commonPage/projectManage/proPreparationDetail", 
                        path:"/common/proPreparationDetail",
                        hidden:true,
                        name:"立项申请详情",
                    },
                    {
                        pageAddress:"cd/CDProjectInfo",
                        path:"/cd/project/track",
                        name:"项目信息",
                        hidden:true,
                    },
                    // {   
                    //     pageAddress:"cm/CMValidProjectIndexView",             
                    //     path:"/cm/project/followUpProject",
                    //     name:"在跟项目",
                    // },
                    {
                        pageAddress:"cm/CMTempProjectReadView", 
                        path:"/cm/temp_project/read_view",
                        hidden:true,
                        name:"在跟项目详情"
                    },
                    // {
                    //     pageAddress:"cm/CMConflictProject",
                    //     path:"/cm/project/conflictProject",
                    //     name:"撞单项目"
                    // },
                    {
                        pageAddress:"commonPage/projectManage/conflictProject",
                        path:"/common/conflictProject",
                        component:"conflictProject",
                        hidden:true,
                        name:"撞单项目详情"
                    },
                    // {
                    //     pageAddress:"commonPage/projectManage/losingList",
                    //     path:"/common/losingList",
                    //     component:"losingList",
                    //     name:"丢单项目"
                    // },
                    {
                        pageAddress:"commonPage/projectManage/losingDetailNew",
                        path:"/commonPage/projectManage/losingDetailNew",
                        component:"losingDetailNew",
                        hidden:true,
                        name:"丢单详情"
                    },
                    {
                        pageAddress:"commonPage/projectManage/losingApply",
                        path:"/commonPage/projectManage/losingApplyBid",
                        component:"losingApply",
                        hidden:true,
                        name:"丢单申请"
                    },

                    // {
                    //     pageAddress:"commonPage/projectManage/guaranteeList",
                    //     path:"/common/guaranteeList",
                    //     component:"guaranteeList",
                    //     name:"保函管理"
                    // },
                    //  {   pageAddress:"commonPage/projectManage/guaranteeListApply",
                    //      path:"/common/guaranteeListApply",
                    //      name:"保函管理(保函专员)",
                    //   },
                    {               
                        pageAddress:"commonPage/projectManage/guaranteeEdit", 
                        path:"/commonPage/projectManage/guaranteeEditBid",
                        component:"guaranteeEdit",
                        hidden:true,
                        name:"保函申请",
                    }, 
                    {               
                        pageAddress:"commonPage/projectManage/guaranteeEdit", 
                        path:"/commonPage/projectManage/guaranteeEditPerformance",
                        component:"guaranteeEdit",
                        hidden:true,
                        name:"保函申请",
                    },
                    {               
                        pageAddress:"commonPage/projectManage/guaranteeDetail", 
                        path:"/commonPage/projectManage/guaranteeDetail",
                        component:"guaranteeDetail",
                        hidden:true,
                        name:"保函详情",
                    },
                ]
            },
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"授信管理",
                menuId: 23,
                children:[
                    // {
                    //     pageAddress:"commonPage/CreditList",
                    //     path:"/common/creditList",
                    //     name:"授信提额"
                    // },
                    {
                        pageAddress:"commonPage/CreditDetail",
                        path:"/common/creditDetail",
                        hidden:true, 
                        name:"项目授信申请详情"
                    },	
                    // {
                    //     pageAddress:"commonPage/CreditorList",
                    //     path:"/common/creditorList",
                    //     name:"授信人员"
                    // },
                    {
                        pageAddress:"commonPage/CreditorDetail",
                        path:"/common/creditorDetail",
                        hidden:true,
                        name:"授信人员详情"
                    },
                    // {
                    //     pageAddress:"commonPage/CreditProjectList",
                    //     path:"/common/CreditProjectList",
                    //     name:"项目管理"
                    // },
                    // {
                    //     pageAddress:"commonPage/creditOrder",
                    //     path:"/common/creditOrder",
                    //     name:"授信订单"
                    // },
                    {
                        pageAddress:"commonPage/creditOrderDetail",
                        path:"/common/creditOrderDetail",
                        hidden:true, 
                        name:"授信订单详情"
                    },	
                ]
            },
            
        ]

    },
    // 合同管理
    {
        path:'/p2',
        redirect: '/common/CMcontractData',
        component: "HomeView",
        name: '合同管理',
        menuId:4,
        parent:true,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"合同管理",
                menuId:15,
                children:[
                    // 客服视窗
                    // {
                    //     pageAddress:"cm/CMcontractData",
                    //     path:"/common/CMcontractData",
                    //     name:"合同总纲",
                    //     meta:{
                    //         keepAlive:true,
                    //     }
                    // },
                    //财务视窗，，
                    // {
                    //     pageAddress:"fm/FMcontractData",
                    //     path:"/common/FMcontractData",
                    //     name:"合同总纲",
                    //     meta:{
                    //         keepAlive:true,
                    //     }
                    // },
                    //行政视窗（保险专员）
					// {
					// 	pageAddress:"commonPage/dataReport/AScontractData",
					// 	path:"/common/AScontractData",
					// 	name:"合同总纲",
					// 	meta:{ 
					// 		keepAlive:true,
                    // 	}
                    //营销视窗(营销经理)
                    // {
					// 	pageAddress:"mm/MMcontractData",
					// 	path:"/common/MMcontractData",
					// 	name:"合同总纲",
					// 	meta:{ 
					// 		keepAlive:true,
					// 	}

                    {
                        pageAddress:"commonPage/dataReport/contractDataInfo",
                        path:"/common/contractDataInfo",
                        hidden:true,
                        name:"合同总纲详情",
                    },
                    
                    {
                        pageAddress:"cm/CMContractReformEdit",
                        path:"/cm/project/CMContractReformAdd",
                        hidden:true,
                        name:"添加变更合同"
                    },
                    {
                        pageAddress:"CommonContractReadView",
                        path:"/cm/contract/read_view",
                        hidden:true,
                        name:"合同详情"
                    },


                    // {
                    //     pageAddress:"cm/CMContractIndexView",
                    //     path:"/cm/project/contractIndex",
                    //     component:"CMContractIndexView",
                    //     name:"待审合同"
                    // },
                    {
						pageAddress:"CommonContractReadView0",
						path:"/cm/contract/read_view0",
						hidden:true,
						name:"待校对合同详情"
                    },
                    {
                        pageAddress:"cm/CMContractEditView0",
                        path:"/cm/project/CMContractEditView0",
                        hidden:true,
                        name:"签约",
                    },
                    {
                        pageAddress:"cm/CMContractEditViewNew",
                        path:"/cm/project/CMContractEditViewNew",
                        hidden:true,
                        name:"编辑合约",
                    },
                     // {
                    //     pageAddress:"cm/CMProjectModifyList",
                    //     path:"/cm/project/CMProjectModifyList",
                    //     component:"CMProjectModifyList",
                    //     name:"变更合同"
                    // },
                    {
                        pageAddress:"cm/CMContractReformEdit",
                        path:"/cm/project/CMContractReformEdit",
                        hidden:true,
                        name:"编辑变更合同"
                    },
                    {
                        pageAddress:"CommonContractModifyDetail",
                        path:"/common/contractModify/CommonContractModifyDetail",
                        hidden:true,
                        name:"变更合同详情"
                    },
                    {
                        pageAddress:"cd/CDTermOfContract",
                        path:"/cd/project/CDTermOfContract",
                        hidden:true,
                        name:"终止合同"
                    },
                    {
                        pageAddress:"commonPage/dataReport/contractDataInfo",
                        path:"/common/termContractDataInfo",
                        hidden:true,
                        name:"终止合同详情",
                    },
                ]
            },
            // {
            //     parent:true,
            //     component:"Navigation",
            //     path:"/home",
            //     name:"印章管理",
            //     menuId:16,
            //     children:[
            //         // {
            //         //     pageAddress:"fm/FMSealList",
            //         //     path:"/fm/FMSealList",
            //         //     name:"用章记录"
            //         // },
            //         {
            //             pageAddress:"fm/FMSealDetail",
            //             path:"/fm/FMSealDetail",
            //             name:"用章详情",
            //             hidden:true,
            //         },
            //         // {
            //         //     pageAddress:"cm/applySeal",
            //         //     path:"/cm/applySeal",
            //         //     name:"盖章申请"
            //         // },
            //         {
            //             pageAddress:"cm/cmApplySealDetail",
            //             path:"/cm/cmApplySealDetail",
            //             name:"盖章申请详情",
            //             hidden:true,
            //         },
            //         {
            //             pageAddress:"cm/cmApplySealEdit",
            //             path:"/cm/cmApplySealEdit",
            //             name:"盖章申请",
            //             hidden:true,
            //         },
            //         // {
            //         //     pageAddress:"cm/sealApply/sealApplicationIndexView",
            //         //     path:"/cm/sealApplicationIndexView",
            //         //     name:"用印申请"
            //         // },
            //         {
            //             pageAddress:"cm/sealApply/sealApplicationAdd",
            //             path:"/cm/sealApplicationAdd",
            //             name:"新增用印申请",
            //             hidden:true,
            //         },
            //         {
            //             pageAddress:"cm/sealApply/sealApplicationEdit",
            //             path:"/cm/sealApplicationEdit",
            //             name:"编辑用印申请",
            //             hidden:true,
            //         },
            //         {
            //             pageAddress:"cm/sealApply/sealApplicationDetail",
            //             path:"/cm/sealApplicationDetail",
            //             name:"审批详情",
            //             hidden:true,
            //         },
            //         {
            //             pageAddress:"cm/sealApply/sealApplicationUpload",
            //             path:"/cm/sealApplicationUpload",
            //             name:"上传盖章文件",
            //             hidden:true,
            //         },
            //     ]
            // }
        ]

    },
    // 工程管理
    {
        path: '/p3',
        component: "HomeView",
        name: '工程管理',
        menuId:5,
        redirect:'/common/engineerList0',
        parent:true,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"质监管理",
                menuId:17,
                children:[
                    //工程总表管理视窗
                    // {
                    //     pageAddress:"commonPage/enginnerManage/engineerList",
                    //     path:"/common/engineerList",
                    //     name:"工程总表"
                    // },
                    //工程总表默认视窗
                    // {
                    //     pageAddress:"commonPage/enginnerManage/engineerList0",
                    //     path:"/common/engineerList0",
                    //     name:"工程总表"
                    // },
                    //项目分配菜单已废弃
                    // {
                    //     pageAddress:"commonPage/broadHeading/AllocationOfItems",
                    //     path:"/common/AllocationOfItems",
                    //     name:"项目分配"
                    // },
                    // {
                    //     pageAddress:"commonPage/broadHeading/LargeProject",
                    //     path:"/common/LargeProject",
                    //     name:"重点项目管理"
                    // },
                    // {
                    //     pageAddress:"commonPage/broadHeading/routineProject",
                    //     path:"/common/routineProject",
                    //     name:"常规项目管理"
                    // },
                     // {
                    //     pageAddress:"commonPage/broadHeading/smallProject",
                    //     path:"/common/smallProject",
                    //     name:"小微项目管理"
                    // },
                    {
                        pageAddress:"commonPage/enginnerManage/engineerDetail",
                        path:"/common/engineerDetail",
                        hidden:true, 
                        component:"engineerDetail",
                        name:"工程详情",
                    },
                    // {
                    //     pageAddress:"commonPage/enginnerManage/constructionScoreList",
                    //     path:"/common/constructionScoreList",
                    //     name:"工地检查评分统计表"
                    // },
                    {
                        pageAddress:"commonPage/enginnerManage/constructionScoreDetail",
                        path:"/common/constructionScoreDetail",
                        component:"constructionScoreDetail",
                        hidden:true,
                        name:"派单详情"
                    },
                    {
                        pageAddress:"commonPage/enginnerManage/securityScoreTable",
                        path:"/common/securityScoreTable",
                        component:"securityScoreTable",
                        hidden:true,
                        name:"工地安全文明施工记录表"
                    },
                    {
                        pageAddress:"commonPage/enginnerManage/qualityScoreTable",
                        path:"/common/qualityScoreTable",
                        component:"qualityScoreTable",
                        hidden:true,
                        name:"工地现场质量监察记录表"
                    },
                    {
                        pageAddress:"commonPage/enginnerManage/projectFinishedTable",
                        path:"/common/projectFinishedTable",
                        component:"projectFinishedTable",
                        hidden:true,
                        name:"工程竣工验收记录表"
                    },
                    
                    // {
                    //     pageAddress:"commonPage/enginnerManage/pmAllGradeList",
                    //     path:"/common/pmAllGradeList",
                    //     name:"项目总监评分汇总表"
                    // },
                    // {
                    //     pageAddress:"commonPage/enginnerManage/returnVisit",
                    //     path:"/common/returnVisit",
                    //     name:"电话回访评分表"
                    // },
                    // {
                    //     pageAddress:"commonPage/enginnerManage/supervisorExamList",
                    //     path:"/common/supervisorExamList",
                    //     name:"工程监理考评表"
                    // },	
                ]
            },
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"公关管理",
                menuId: 84,
                children:[
                    // {
                    //     pageAddress:"commonPage/projectManage/injuriesList",
                    //     path:"/common/injuriesList",
                    //     component:"injuriesList",
                    //     name:"事故管理"
                    // },
                    {
                        pageAddress:"commonPage/projectManage/injuriesDetail",
                        path:"/common/injuriesDetail",
                        component:"injuriesDetail",
                        name:"事故详情",
                        hidden:true,
                    },
                    {
                        pageAddress:"commonPage/projectManage/injuriesModify",
                        path:"/common/injuriesModify",
                        component:"injuriesModify",
                        name:"编辑事故详情",
                        hidden:true,
                    },
                    // {
                    //     pageAddress:"commonPage/complaintManage/complaintList",
                    //     path:"/common/complaintList",
                    //     component:"complaintList",
                    //     name:"投诉管理"
                    // },	
                    {
                        pageAddress:"commonPage/complaintManage/addComplainList",
                        path:"/common/addComplainList",
                        hidden:true, 
                        component:"addComplainList",
                        name:"添加投诉"
                    },
                    {
                        pageAddress:"commonPage/complaintManage/complaintDetail",
                        path:"/common/complaintDetail",
                        hidden:true, 
                        component:"complaintDetail",
                        name:"投诉详情"
                    }
                    // },
                ]
            },
        ]
    },
    // 材料管理
    {
		path:'/p4',
        redirect: '/common/materialList',
        component: "HomeView",
        name: '材料管理',
        menuId:6,
        parent:true,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"代付材料",
                menuId:18,
                children:[
                    //管理视窗
                    // {
                    //     pageAddress:"commonPage/financeManage/materialList2",
                    //     path:"/common/materialList2",
                    //     name:"代付申请列表"
                    // },
                    //默认视窗
                    // {
                    //     pageAddress:"commonPage/financeManage/materialList",
                    //     path:"/common/materialList",
                    //     name:"代付申请列表"
                    // },
                    {
                        pageAddress:"commonPage/financeManage/materialDetail",
                        path:"/common/materialDetail",
                        hidden:true,
                        name:"代付材料申请详情",
                        // 详情页面返回列表页要去被缓存
                        // meta: {
                        //     requiresAuth: true,
                        //     privilege: ['capacityStatus'],
                        // }
                    },
                    {
                        pageAddress:"commonPage/financeManage/materialApply",
                        path:"/common/materialApply",
                        hidden:true,
                        name:"编辑代付材料申请"
                    },
                    {
                        pageAddress:"commonPage/financeManage/editMargin",
                        path:"/common/editMargin",
                        hidden:true,
                        name:"编辑代付投标保证金申请"
                    },
                    {
                        pageAddress:"commonPage/financeManage/editDeposit",
                        path:"/common/editDeposit",
                        hidden:true,
                        name:"编辑代付物业押金"
                    },
                    {
                        pageAddress:"commonPage/financeManage/addMargin",
                        path:"/common/addMargin",
                        hidden:true,
                        name:"新增代付投标保证金申请"
                    },
                    {
                        pageAddress:"commonPage/financeManage/deposit",
                        path:"/common/deposit",
                        hidden:true,
                        name:"新增代付物业押金"
                    },
                    {
                        pageAddress:"commonPage/financeManage/marginDetail",
                        path:"/common/marginDetail",
                        hidden:true,
                        name:"代付投标保证金申请详情"
                    },
                    {
                        pageAddress:"commonPage/financeManage/depositDetail",
                        path:"/common/depositDetail",
                        hidden:true,
                        name:"代付物业押金申请详情"
                    },
                    // {
                    //     pageAddress:"commonPage/financeManage/purchaseList",
                    //     path:"/common/purchaseList",
                    //     name:"材料购销合同"
                    // },
                    {
                        pageAddress:"commonPage/financeManage/purchaseDetail",
                        path:"/common/purchaseDetail",
                        hidden:true,
                        name:"材料购销合同详情"
                    },
                    {
                        pageAddress:"commonPage/financeManage/purchaseEdit",
                        path:"/common/purchaseEdit",
                        hidden:true,
                        name:"编辑材料购销合同"
                    },
                    {
                        pageAddress:"commonPage/financeManage/purchaseApply",
                        path:"/common/purchaseApply",
                        hidden:true,
                        name:"新增材料购销合同"
                    },
                ]
            },
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"众惠材料",
                menuId: 19,
                children:[
                    // {
                    //     pageAddress:"commonPage/financeManage/zhotyImportList",
                    //     path:"/common/zhotyImportList",
                    //     name:"材料导入记录"
                    // },
                ]
            }
        ]

    },
    // 财务管理
    {
        path:'/p5',
        redirect: '/fm/FMStatProjectIndexView',
        component: "HomeView",
        name: '财务管理',
        menuId:7,
        parent:true,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"总表视图",
                menuId: 20,
                children:[
                    //财务总表菜单已废弃不要
                    // {
                    //     pageAddress:"commonPage/dataReport/financeData",
                    //     path:"/common/financeData",
                    //     component:"financeData",
                    //     name:"财务总表",
                    //     meta:{
                    //         keepAlive:true,
                    //     }
                    // },
                    
                    {
                        pageAddress:"commonPage/dataReport/financeDataInfo",
                        path:"/common/financeDataInfo",
                        component:"financeDataInfo",
                        hidden:true,
                        name:"财务数据详情"
                    },


                    // {
                    //     pageAddress:"fm/FMStatProjectIndexView",
                    //     path:"/fm/FMStatProjectIndexView",
                    //     name:"项目视图"
                    // },
                    {
                        pageAddress:"fm/FMStatProjectReadView",
                        path:"/fm/FMStatProjectReadView",
                        hidden:true,
                        name:"项目细节"
                    },
                    {
                        pageAddress:"fm/FMStatProjectReadView2",
                        path:"/fm/FMStatProjectReadView2",
                        hidden:true,
                        name:"项目细节"
                    },
                    {
                        pageAddress:"fm/FMContractEditView",
                        path:"/fm/FMContractEditView",
                        hidden:true,
                        name:"编辑合约"
                    },
                     // {
                    //     pageAddress:"fm/FinishProjectIndexView",
                    //     path:"/fm/FinishProjectIndexView",
                    //     name:"完工结算"
                    // },
                    {
                        pageAddress:"cm/CMFinishedAccountDetail",
                        path:"/cm/CMFinishedAccountDetail",
                        hidden:true,
                        name:"结算详情"
                    },
                ]
            },
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"资金管理",
                menuId: 21,
                children:[
                    //管理视窗
                     // {
                    //     pageAddress:"fm/FMFinanceIncomeIndexView2",
                    //     path:"/fm/FMFinanceIncomeIndexView2",
                    //     name:"收款流水"
                    // },
                    // {
                    //     pageAddress:"fm/FMFinanceIncomeIndexView",
                    //     path:"/fm/FMFinanceIncomeIndexView",
                    //     name:"收款流水"
                    // },
                    // {
                    //     pageAddress:"cm/CMFinanceIncomeIndexView",
                    //     path:"/cm/financeIncome/index",
                    //     name:"收款流水"
                    // },
                    // {
                    //     pageAddress:"finance/FinanceFinanceIncomeIndexView",
                    //     path:"/finance/financeIncome/index",
                    //     name:"收款流水"
                    // },
                    // {
                    //     pageAddress:"fm/FMFinanceIncomeEditView",
                    //     path:"/fm/financeIncome/edit",
                    //     hidden:true,
                    //     name:"收款流水细节"
                    // },	
                    {
                        pageAddress:"fm/FMFinanceIncomeReadView",
                        path:"/fm/financeIncome/read",
                        hidden:true,
                        name:"流水信息"
                    },
                    {
                        pageAddress:"cm/CMFinanceIncomeEditView",
                        path:"/cm/financeIncome/edit",
                        hidden:true,
                        name:"认领收款流水"
                    },
                    {
                        pageAddress:"process/CommonFinanceIncomeReadView",
                        path:"/cm/common/finance_income/read_view",
                        hidden:true,
                        name:"收款流水细节"
                    },
                    {
                        pageAddress:"finance/FinanceFinanceIncomeEditView",
                        path:"/finance/financeIncome/edit",
                        hidden:true,
                        name:"编辑收款流水"
                    },
                    // 管理视窗
                     // { 
                    //     pageAddress:"finance/insuranceList2",
                    //     path: '/finance/insurance2',
                    //     name: '保险记录',
                    // },
                     // { 
                    //     pageAddress:"finance/insuranceList",
                    //     path: '/finance/insurance',
                    //     name: '保险记录',
                    // },
                    {
                        pageAddress:"finance/insuranceAdd",
                        path:"/finance/insuranceAdd",
                        hidden:true,
                        name:"添加保险"
                    },
                    {
                        pageAddress:"finance/insuranceDetail",
                        path:"/finance/insuranceDetail",
                        hidden:true,
                        name:"保险详情"
                    },

                     // 管理视窗
                    // {
                    //     pageAddress:"commonPage/financeManage/servicePayList2",
                    //     path:"/common/servicePayList2",
                    //     name:"劳务支付"
                    // },
                    // {
                    //     pageAddress:"commonPage/financeManage/servicePayList",
                    //     path:"/common/servicePayList",
                    //     name:"劳务支付"
                    // },
                    {
                        pageAddress:"commonPage/financeManage/servicePayDetail",
                        path:"/common/servicePayDetail",
                        hidden:true,
                        name:"劳务支付详情"
                    },	
                    {
                        pageAddress:"commonPage/financeManage/servicePayApply",
                        path:"/common/servicePayApply",
                        hidden:true,
                        name:"新增劳务支付"
                    },
                    {
                        pageAddress:"commonPage/financeManage/servicePayEdit",
                        path:"/common/servicePayEdit",
                        hidden:true,
                        name:"编辑劳务支付"
                    },
                    {
                        pageAddress:"commonPage/financeManage/refundTaxesApply",
                        path:"/common/refundTaxesApply",
                        hidden:true,
                        name:"退预缴税费申请"
                    },
                    {
                        pageAddress:"commonPage/financeManage/refundTaxesDetails",
                        path:"/common/refundTaxesDetails",
                        hidden:true,
                        name:"退预缴税费申请详情"
                    },
                    {
                        pageAddress:"commonPage/financeManage/RiskRefund",
                        path:"/common/RiskRefund",
                        hidden:true,
                        name:"退风险金"
                    },
                    {
                        pageAddress:"commonPage/financeManage/RiskFundDetails",
                        path:"/common/RiskFundDetails",
                        hidden:true,
                        name:"退风险金详情"
                    },
                    //管理视窗
                    // {
                    //     pageAddress:"fm/FMDeductionList2",
                    //     path:"/fm/FMDeductionList2",
                    //     name:"手动扣款", 
                    // },
                    //默认视窗
                    // {
                    //     pageAddress:"fm/FMDeductionList",
                    //     path:"/fm/FMDeductionList",
                    //     name:"手动扣款", 
                    // },
                    {
                        pageAddress:"fm/FMAddDeduction",
                        path:"/fm/FMAddDeduction",
                        hidden:true,
                        name:"添加手动扣款", 
                    },	
                    {
                        pageAddress:"fm/FMDeductionDetail",
                        path:"/fm/FMDeductionDetail",
                        hidden:true,
                        name:"手动扣款详情", 
                    },	
                    // {
                    //     pageAddress:"commonPage/financeManage/applyPaymentList",
                    //     path:"/common/applyPaymentList",
                    //     meta: {
                    //         keepAlive: true // 需要被缓存
                    //     },
                    //     name:"用款申请"
                    // },
                    {
                        pageAddress:"commonPage/financeManage/applyPaymentDetail",
                        path:"/common/applyPaymentDetail",
                        hidden:true,
                        name:"用款申请详情"
                    },	
                    // {
                    //     pageAddress:"commonPage/financeManage/systemCommissionList",
                    //     path:"/common/systemCommissionList",
                    //     name:"系统提成"
                    // },
                    {
                        pageAddress:"commonPage/financeManage/systemCommissionDetail",
                        path:"/common/systemCommissionDetail",
                        hidden:true,
                        name:"系统提成详情"
                    },	



                ]
            },
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"发票管理",
                menuId: 22,
                children:[
                    // 管理视窗
                    // {
                    //     pageAddress:"fm/FmOutPutTicket2",
                    //     path:"/fm/FmOutPutTicket2",
                    //     name:"销项票"
                    // },	
                    // {
                    //     pageAddress:"fm/FmOutPutTicket",
                    //     path:"/fm/FmOutPutTicket",
                    //     name:"销项票"
                    // },		
                    {
                        pageAddress:"fm/FmOutPutTicketDetail",
                        path:"/fm/FmOutPutTicketDetail",
                        hidden:true,
                        name:"开票详情"
                    },	
                    {
                        pageAddress:"fm/FmAddOutPutTicket",
                        path:"/fm/FmAddOutPutTicket",
                        hidden:true,
                        name:"新增开票申请"
                    },	
                    {
                        pageAddress:"fm/FmEditOutPutTicket",
                        path:"/fm/FmEditOutPutTicket",
                        hidden:true,
                        name:"编辑开票申请"
                    },
                    {
                        pageAddress:"fm/FmRedPunch",
                        path:"/fm/FmRedPunch",
                        hidden:true,
                        name:"发票红冲申请"
                    },	
                    
					// {
                    //     pageAddress:"fm/FMVoidRecord",
                    //     path:"/fm/FMVoidRecord",
                    //     name:"作废记录"
                    // },
                    {
                        pageAddress:"fm/FMVoidRecordDetail",
                        path:"/fm/FMVoidRecordDetail",
                        hidden:true,
                        name:"销项票作废记录详情"
                    },

                    // {   pageAddress:"fm/FmEntryTicket",
                    //     path:"/fm/FmEntryTicket",
                    //     name:"进项票"
                    // },
                    {
                        pageAddress:"fm/FmEntryTicketDetail",
                        path:"/fm/FmEntryTicketDetail",
                        hidden:true,
                        name:"进项票详情"
                    },	
                    {
                        pageAddress:"fm/FmAddEntryTicket",
                        path:"/fm/FmAddEntryTicket",
                        hidden:true,
                        name:"新增进项票"
                    },	
                    // {   
                    //     pageAddress:"fm/prepaidTax",
                    //     path:"/fm/prepaidTax",
                    //     name:"预缴税费"
                    // },
                    {
                        pageAddress:"fm/prepaidTaxForm",
                        path:"/fm/prepaidTaxForm",
                        hidden:true,
                        name:"预缴税费申请"
                    },	
                    {
                        pageAddress:"fm/prepaidTaxDetail",
                        path:"/fm/prepaidTaxDetail",
                        hidden:true,
                        name:"预缴税费详情"
                    },	
                    // {
                    //     pageAddress:"cm/CMApplyDataIndexView",
                    //     path:"/cm/CMApplyDataIndexView",
                    //     name:"申请列表"
                    // },
                    {
                        pageAddress:"cm/ApplyData/ApplyDataEditView01",
                        path:"/cm/applyData/edit01",
                        hidden:true,
                        name:"盖章申请"
                    },
                    {
        
                        pageAddress:"cm/ApplyData/ApplyDataEditView02",
                        path:"/cm/applyData/edit02",
                        hidden:true,
                        name:"发票申请"
                    },
        
                    {
                        pageAddress:"cm/ApplyData/ApplyDataEditView03",
                        path:"/cm/applyData/edit03",
                        hidden:true,
                        name:"提现申请"
                    },
                    {
                        pageAddress:"cm/ApplyData/ApplyDataEditView04",
                        path:"/cm/applyData/edit04",
                        hidden:true,
                        name:"代付材料申请"
                    },
        
                    {
                        pageAddress:"cm/ApplyData/ApplyDataEditView05",
                        path:"/cm/applyData/edit05",
                        hidden:true,
                        name:"授信提额申请"
                    },
                ]
            },
            
        ]
    }, 
    // 精英库管理
    {
        path: '/p6',
        component: "HomeView",
        name: '精英库管理',
        menuId:8,
        // redirect:'/ba/cm/projectManagerList',
        parent:true,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"人员管理",
                menuId: 24,
                children:[
                    //客户总监视窗
                    // {
                    //     pageAddress:"CMProjectManagerView",
                    //     path:"/cm/CMProjectManagerView",
                    //     name:"项目总监总表"
                    // },
                    //商务视窗
                    // {
                    //     pageAddress:"BAProjectManagerView",
                    //     path:"/ba/BAProjectManagerView",
                    //     name:"项目总监总表"
                    // },
                    //默认视窗
                    // {
                    //     pageAddress:"ProjectManagerListView",
                    //     path:"/pm/CDProjectManagerView",
                    //     name:"项目总监总表"
                    // },
                    //默认视窗
                    // {
                    //     pageAddress:"BAProjectManagerView2",
                    //     path:"/babm/BAProjectManagerView2",
                    //     name:"商务部项目总监总表"
                    // },
                    //默认视窗
                    // {
                    //     pageAddress:"CMProjectManagerView2",
                    //     path:"/cd/CMProjectManagerView2",
                    //     name:"客户部项目总监总表"
                    // },
                    {
                        pageAddress:"ba/BAProjectManagerAddView",
                        path:"/ba/pm/add",
                        name:"新增项目总监",
                        hidden:true,
                    },
                    {
                        pageAddress:"ba/BAProjectManagerEditViewNew",
                        path:"/ba/pm/edit",
                        hidden:true,
                        name:"编辑人员"
                    },
                    {
                        pageAddress:"cd/CDProjectManagerEditViewNew",//新
                        path:"/cd/pm/edit",
                        hidden:true,
                        name:"人员详情"
                    },
                    {
                        pageAddress:"bm/BMProjectManagerReadView", 
                        path:"/ba/pm/read_view",
                        hidden:true,
                        name:"人员详情"
                    },
                    {
                        pageAddress:"cd/CDprojectDirector",
                        path:"/cm/pm/projectDirector",
                        hidden:true,
                        name:"查看人员"
                    },
                    {
                        pageAddress:"cd/CDinterviewRecord",
                        path:"/cm/pm/interviewRecord",
                        hidden:true,
                        name:"人员管理---访谈记录"
                    },
                    {
                        pageAddress:"cd/CDprojectInformation",
                        path:"/cd/pm/projectInformation",
                        hidden:true,
                        name:"查看人员项目信息"
                    },
                    {
                        pageAddress:"pm/pmComplaintList",
                        path:"/pm/pmComplaintList",
                        hidden:true,
                        name:"投诉处理"
                    },
                   
                    // {
                    //     pageAddress:"pm/frozenList",
                    //     path:"/pm/frozenList",
                    //     name:"冻结名单"
                    // },
                    {
                        pageAddress:"cd/CDProjectManagerEditViewNew",//新
                        path:"/cd/pm/edit",
                        hidden:true,
                        name:"冻结名单详情"
                    },
                    // {
                    //     pageAddress:"cd/pmBlackList",
                    //     path:"/cd/pm/pmBlackList",
                    //     name:"项目总监黑名单"
                    // },
                    {
                        pageAddress:"cd/pmBlackDetail",
                        path:"/cd/pm/pmBlackDetail",
                        name:"人员详情",
                        hidden:true,
                    },
                    {
                        pageAddress:"ExecutiveProjectManagerView",
                        path:"/insCommissioner/ExecutiveProjectManagerView",
                        name:"人员总表",
                        hidden:true,
                    },
                ]
            },
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"工人管理",
                menuId: 124,
                children:[
                    // {
                    //     pageAddress:"pm/workerManage/workerList",
                    //     path:"/pm/workerManage",
                    //     name:"工人总表",
                    // },
                    {
                        pageAddress:"pm/workerManage/workerDetail",
                        path:"/pm/workerDetail",
                        hidden:true,
                        name:"工人详情"
                    },
                    {
                        pageAddress: "pm/workerManage/workerEdit",
                        path:"/pm/workerEdit",
                        hidden:true,
                        name:"编辑工人"
                    }
                ]
            },
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"业务管理",
                menuId: 91,
                children:[
                     // {
                    //     pageAddress:"cm/CMIntroducerIndexView",
                    //     path:"/cm/introducer/index",
                    //     name:"项目总监关系管理"
                    // },
                    {
                        pageAddress:"cm/CMIntroducerInfo",
                        path:"/cm/introducer/infor",
                        hidden:true,
                        name:"项目总监关系管理详情"
                    },
                    {
                        pageAddress:"cm/CMIntroducerAddView",
                        path:"/cm/introducer/edit",
                        hidden:true,
                        component:"CMIntroducerAddView",
                        name:"介绍人编辑"
                    },
                    // {
                    //     pageAddress:"commonPage/pmManage/pmInterviewList",
                    //     path:"/common/pmInterviewList",
                    //     name:"项目总监访谈记录"
                    // },
                    {
                        pageAddress:"commonPage/pmManage/pmInterviewDetail",
                        path:"/common/pmInterviewDetail",
                        component:"pmInterviewDetail",
                        hidden:true,
                        name:"访谈记录详情"
                    },
                    {
                        pageAddress:"commonPage/pmManage/pmInterviewAdd",
                        path:"/common/pmInterviewAdd",
                        component:"pmInterviewAdd",
                        hidden:true,
                        name:"添加访谈记录"
                    },
                ]
            },
        ]
    },
    // 客户管理
    {
		path:'/p7',
        redirect: '/cm/customer/index',
        component: "HomeView",
        name: '客户管理',
        menuId:9,
        parent:true,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"客户管理",
                menuId:25,
                children:[
                    // {
                    //     pageAddress:"cm/CMCustomerIndexView",
                    //     path:"/cm/customer/index",
                    //     name:"甲方管理"
                    // },
                    // {
                    //     pageAddress:"cm/toBeImprovedCustomer",
                    //     path:"/cm/customer/toBeImproved",
                    //     name:"待补录甲方"
                    // },
                    {
                        pageAddress:"cm/CMCustomerAddOrEditView", 
                        path:"/cm/customer/addoredit",
                        hidden:true,
                        name:"编辑甲方公司"
                    },
                    {
                        pageAddress:"cm/CMCustomerDetail", 
                        path:"/cm/customer/detail",
                        hidden:true,
                        name:"甲方公司详情"
                    },
                    // {
                    //     pageAddress:"cm/beRecordList",
                    //     path:"/cm/beRecord",
                    //     name:"入库备案"
                    // },
                    {
                        pageAddress:"cm/beRecordDetail", 
                        path:"/cm/beRecordDetail",
                        hidden:true,
                        name:"入库详情"
                    },
                    {
                        pageAddress:"cm/beRecordAdd",
                        path:"/cm/beRecordAdd",
                        name:"添加信息",
                        hidden:true,
                    },
                    {
                        pageAddress:"cm/beRecordEdit",
                        path:"/cm/beRecordEdit",
                        hidden:true,
                        name:"编辑信息"
                    },
                ]
            },
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"供应商管理",
                menuId:158,
                children:[
                    {
                        pageAddress:"customer/supplierDetails",
                        path:"/customer/supplierDetails",
                        hidden:true,
                        name:"供应商详情",
                    },
                    {
                        pageAddress:"customer/supplierEdit",
                        path:"/customer/supplierEdit",
                        hidden:true,
                        name:"编辑供应商",
                    },
                ]
            },
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"合作公司管理",
                menuId:121,
                children:[
                    {
                        pageAddress:"cm/CooperativeCompany",
                        path:"/cm/customer/CooperativeCompany",
                        name:"合作公司",
                    },
                ]
            },
        ]

    },
    // 系统管理
    {
		path:'/p8',
        redirect: '/user/index',
        component: "HomeView",
        name: '系统管理',
        menuId:10,
        parent:true,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name: "工单管理",
                menuId: 175,
                children: [
                    {
                        pageAddress: "admin/WorkOrderAdd",
                        path: "/admin/WorkOrderAdd",
                        hidden: true,
                        name: "新增工单"
                    },
                    {
                        pageAddress: "admin/WorkOrderDetail",
                        path: "/admin/WorkOrderDetail",
                        hidden: true,
                        name: "工单详情"
                    },
                    {
                        pageAddress: "admin/WorkOrderEdit",
                        path: "/admin/WorkOrderEdit",
                        hidden: true,
                        name: "编辑工单"
                    },
                ]
            },
            {
                parent: true,
                component: "Navigation",
                path: "/home",
                name:"账户设置",
                menuId:26,
                children:[
                    // { 
                    //     path: '/user/index',
                    //     pageAddress:"commonPage/UserIndexView",
                    //     name: '员工账号管理' 
                    // },
                    {
                        pageAddress:"commonPage/AccountDetail",
                        path:"/UserIndexView/detail",
                        hidden:true,
                        name:"员工账号详情"
                    },
                    // { 
                    //     pageAddress:"RoleManagement",
                    //     path: '/user/RoleManagement',
                    //     name: '角色管理' 
                    // },
                    // { 
                    //     pageAddress:"OrganizationalManagement",
                    //     path: '/user/OrganizationalManagement',
                    //     name: '组织架构管理' 
                    // },
                    
                     
                ]
            },
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"通用设置",
                menuId: 27,
                children:[
                    // {                 
                    //     path: '/admin/sub_company/index', 
                    //     component: "SubCompanyIndexView", 
                    //     name: '新美子公司数据',
                    // },
                    {                 
                        path: '/admin/SubCompanyInfo', 
                        component: "SubCompanyInfo", 
                        hidden: true, 
                        name: '新美子公司详情',
                    },
                    {                 
                        path: '/admin/SubCompanyEditView', 
                        component: "SubCompanyEditView", 
                        hidden: true, 
                        name: '编辑子公司',
                    },
                    // { 
                    //     path: '/admin/operation_center/index', 
                    //     component: "OperationCenterView", 
                    //     name: '运营中心数据',
                    // },
                    // { 
                    //     path: '/admin/engineering/index', 
                    //     component: "EngineeringIndex", 
                    //     name: '公装类型' 
                    // },
                    // { 
                    //     path: '/admin/ProvincialUrban/index', 
                    //     component: "ProvincialUrbanIndex", 
                    //     name: '省市区数据' 
                    // },
                    // { 
                    //     path: '/admin/bank_name_data/index', 
                    //     component: "BankNameDataView", 
                    //     name: '银行数据' 
                    // },
                    // { 
                    //     path: '/admin/enum_cat/index', 
                    //     component: "EnumCatView", 
                    //     name: '枚举分类' 
                    // },
                    // { 
                    //     path: '/admin/enum_data/index', 
                    //     component: "EnumDataIndexView", 
                    //     name: '枚举数据' 
                    // },
                ]
            },
            // {
            //     parent:true,
            //     component:"Navigation",
            //     path:"/home",
            //     name:"系统监控",
            //     menuId: 181,
            //     children:[
            //         // { 
            //         //     path: '/admin/springboot/adminconsole', 
            //         //     component: "Adminconsole", 
            //         //     name: 'Admin控制台' 
            //         // },
            //     ]
            // },
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"个人设置",
                menuId: 28,
                children:[
                    // { 
                    //     path: '/me/change_password', 
                    //     component: "ChangePasswordView", 
                    //     name: '修改密码' 
                    // },	
                    // {
                    //     pageAddress:"cm/CMChangePWView",
                    //     path:"/cm/information/changePW",
                    //     name:"修改密码"
                    // }
                ]
            }
        ]

    },
    {
        pageAddress:"commonPage/enginnerManage/returnVisitTable",
        path:"/common/returnVisitTable",
        component:"returnVisitTable",
        hidden:true,
        // name:"回访表"
    },
    {
        pageAddress:"commonPage/enginnerManage/finishProjectTable",
        path:"/common/finishProjectTable",
        component:"finishProjectTable",
        hidden:true,
        // name:"竣工验收记录表"
        // name:"竣工确认单"
    },
    {
        pageAddress:"commonPage/enginnerManage/startProjectTable",
        path:"/common/startProjectTable",
        component:"startProjectTable",
        hidden:true,
        // name:"开工确认单"
    },
    // {
    //     pageAddress:"commonPage/enginnerManage/constructionScoreDetail",
    //     path:"/common/constructionScoreDetail",
    //     component:"constructionScoreDetail",
    //     hidden:true,
    //     // name:"工地检查评分统计表"
    // },
    {
        pageAddress:"commonPage/financeManage/materialPrint",
        path:"/common/materialPrint",
        hidden:true,
        name:"打印付款申请单"
    },
    {
        pageAddress:"commonPage/financeManage/marginPrint",
        path:"/common/marginPrint",
        hidden:true,
        name:"打印代付投标保证金"
    },
    {   
        pageAddress:"commonPage/financeManage/depositPrint",
        path:"/common/depositPrint",
        hidden:true,
        name:"打印物业押金"
    },
    {
        pageAddress:"commonPage/dataReport/printSettleForm",
        path:"/common/printSettleForm",
        component:"printSettleForm",
        hidden:true,
        name:"打印结算表"
    }, 
    // {
    //     pageAddress:"commonPage/financeManage/NewXiangmushitu",
    //     path:"/common/New",
    //     hidden:true,
    //     name:"项目视图新建页面导出数据"
    // },
    {
        pageAddress:"fm/receiptConfirmation",
        path:"/fm/financeIncome/receiptConfirmation",
        hidden:true,
        name:"打印收款流水"
    },
    {
        pageAddress:"commonPage/financeManage/serviceFeePrint",
        path:"/common/serviceFeePrint",
        hidden:true,
        name:"打印劳务支付"
    },	
    {
        pageAddress:"commonPage/financeManage/refundTaxesPrint",
        path:"/common/refundTaxesPrint",
        hidden:true,
        name:"打印退预缴税费申请表"
    },	
    {
        pageAddress:"commonPage/financeManage/riskRefundPrint",
        path:"/common/riskRefundPrint",
        hidden:true,
        name:"打印退风险金申请表"
    },	
    {
        pageAddress:"fm/printOutPutTicket",
        path:"/common/printOutPutTicket",
        component:"printOutPutTicket",
        hidden:true,
        name:"打印销项票"
    },
    {
        pageAddress:"commonPage/enginnerManage/monitors",
        path:"/common/monitors",
        hidden:true, 
        name:"视频监控"
    },
    {
        pageAddress:"fm/prepaidTaxPrint",
        path:"/common/prepaidTaxPrint",
        hidden:true,
        name:"打印预缴税费申请"
    },	
]

export default commonMenu;


// WEBPACK FOOTER //
// ./src/menu/menu.js